import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { formPaths } from '@shared/constants/form-paths.const';
import { getNatMutControl, getSchedaPrevalenzaControl } from '../validators/helpers/natura-mutualistica-form-validators.helper';

export const setNatMutCkMutualisticiListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_CkMutualPrev(form, store);
    my_RegimeDerogatorioProvalenza(form, store);
    my_RegimeDerogatorioProvalenzaFakeSync(form);
    my_DescRegimeDerogatorioProvalenzaFakeSync(form);
};

const my_CkMutualPrev = (form: FormGroup, store: Store<Revisione53State>): void => {
    const ckMutualControl = getControl(form, `${formPaths.datiIdentificativi}.my_CkMutualPrev`);
    ckMutualControl.valueChanges.pipe(withInitialValueDebounced(ckMutualControl)).subscribe((my_CkMutualPrev: string) => {
        if (!isNilOrEmpty(my_CkMutualPrev)) {
            getSchedaPrevalenzaControl(form, 'my_CkIscrizAlboCoopMutP').patchValue(my_CkMutualPrev, { emitEvent: false });
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP = my_CkMutualPrev;
                return myVerbaleClone;
            });
        }
    });
};

const my_RegimeDerogatorioProvalenza = (form: FormGroup, store: Store<Revisione53State>): void => {
    const my_CkRientraRegDerogatoriControl = getNatMutControl(form, 'my_CkRientraRegDerogatori');
    const my_RegimeDerogatorioProvalenzaControl = getControl(form, `${formPaths.datiIdentificativi}.my_RegimeDerogatorioProvalenza`);
    my_RegimeDerogatorioProvalenzaControl.valueChanges.pipe(withInitialValueDebounced(my_RegimeDerogatorioProvalenzaControl)).subscribe((my_RegimeDerogatorioProvalenza) => {
        const value = my_RegimeDerogatorioProvalenza === '1' || isNilOrEmpty(my_RegimeDerogatorioProvalenza) ? '0' : '1';
        my_CkRientraRegDerogatoriControl.patchValue(value, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkRientraRegDerogatori = value;
            return myVerbaleClone;
        });
    });
};

/** Keeps my_RegimeDerogatorioProvalenza and its fake mirror in sync when either changes. */
const my_RegimeDerogatorioProvalenzaFakeSync = (form: FormGroup): void => {
    const realControl = getControl(form, `${formPaths.datiIdentificativi}.my_RegimeDerogatorioProvalenza`);
    const fakeControl = getControl(form, `${formPaths.datiIdentificativi}.my_FakeRegimeDerogatorioProvalenza`);
    realControl.valueChanges.pipe(withChangeDebounced(realControl)).subscribe((value: string) => {
        if (fakeControl.value !== value) {
            fakeControl.patchValue(value, { emitEvent: false });
        }
    });
    fakeControl.valueChanges.pipe(withChangeDebounced(fakeControl)).subscribe((value: string) => {
        if (realControl.value !== value) {
            realControl.patchValue(value, { emitEvent: false });
        }
    });
};

/** Keeps my_DescRegimeDerogatorioProvalenza and its fake mirror in sync when either changes. */
const my_DescRegimeDerogatorioProvalenzaFakeSync = (form: FormGroup): void => {
    const realControl = getControl(form, `${formPaths.datiIdentificativi}.my_DescRegimeDerogatorioProvalenza`);
    const fakeControl = getControl(form, `${formPaths.datiIdentificativi}.my_FakeDescRegimeDerogatorioProvalenza`);
    realControl.valueChanges.pipe(withChangeDebounced(realControl)).subscribe((value: string) => {
        if (fakeControl.value !== value) {
            fakeControl.patchValue(value, { emitEvent: false });
        }
    });
    fakeControl.valueChanges.pipe(withChangeDebounced(fakeControl)).subscribe((value: string) => {
        if (realControl.value !== value) {
            realControl.patchValue(value, { emitEvent: false });
        }
    });
};
